import { memo } from 'react';

import type { Props } from './TranslationNodeRichText.types';

import style from './TranslationNodeRichText.module.css';

export const TranslationNodeRichText = memo<Props>(({ node }) => {
  return (
    <div
      className={style.node}
      dangerouslySetInnerHTML={{ __html: node.value }}
    />
  );
});
